import { Component, EventEmitter, Inject, Input, Output, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StatementService } from 'src/app/pages/privado/services/previdencia/statement.service';
import { ModalFormularioCoafComponent } from 'src/app/shared/modals/modal-formulario-coaf/modal-formulario-coaf.component';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
@Component({
  selector: 'formulario-cargo-politico',
  templateUrl: './formulario-cargo-politico.component.html',
  styleUrls: ['./formulario-cargo-politico.component.css']
})
export class FormularioCargoPoliticoComponent {
  @Input() titulo!: string;
  @Input() tipoCargo!: number;
  @Output() sendEmitter: EventEmitter<any> = new EventEmitter();
  todaysDate: any = new Date().toJSON().split('T')[0];
  positions!: any[];
  familyGroupTypes!: any[];
  formFamiliar: FormGroup = this.formBuilder.group({
    name: new FormControl(null, [Validators.required]),
    initialDate: new FormControl(null, [Validators.required]),
    finalDate: new FormControl(null),
    exposedPersonPositionId: new FormControl(null, [Validators.required]),
    exposedPersonStatementTypeId: new FormControl(null),
    familyGroupTypeId: new FormControl(null, [Validators.required]),
  });
  form: FormGroup = this.formBuilder.group({
    name: new FormControl(null, [Validators.required]),
    initialDate: new FormControl(null, [Validators.required]),
    finalDate: new FormControl(null),
    exposedPersonPositionId: new FormControl(null, [Validators.required]),
    exposedPersonStatementTypeId: new FormControl(null),
  });
  constructor(
    @Inject(FormBuilder) private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private statementPPEService: StatementService,
    private userService: UsuarioService,
    private renderer: Renderer2) {
    //CARGOS
    this.statementPPEService.getPositions().subscribe((res: any) => {
      this.positions = res;
    });
    this.userService.getFamilyGroupTypes().subscribe((res: any) => {
      res.forEach((resp: any) => {
        resp.value = resp.value.trim().toUpperCase();
      })
      this.familyGroupTypes = res;
    });
  }
  // openModal(index: any, formGroup: FormGroup, $event: Event) {
  openModal(id: number) {
    const modalRef = this.modalService.open(ModalFormularioCoafComponent, { windowClass: 'carteirinha-modal-size', centered: true });
    modalRef.componentInstance.positions = this.positions;
    modalRef.result.then((result) => {
      // this.sendEmitter.emit(result.value);
      (id == 1) ? this.form.get('exposedPersonPositionId')?.setValue(result.key + ' - ' + result.value) : this.formFamiliar.get('exposedPersonPositionId')?.setValue(result.key + ' - ' + result.value);
      this.renderer.selectRootElement('#inputField').blur();
      document.getElementById("inputField")?.blur();
      // formGroup.get('job').patchValue(result.key + ' - ' + result.value.toUpperCase())
      // formGroup.get('exposedPersonPositionId').setValue(result.key)
      // formGroup.get('job').updateValueAndValidity();
    }, (reason) => {
      // formGroup.get('job').setErrors({ 'incorrect': true });
    });
  }
  adicionarFamiliar() {
    this.formFamiliar.get('exposedPersonStatementTypeId')?.setValue(this.tipoCargo);
    this.formFamiliar.get('exposedPersonPositionId')?.setValue((this.formFamiliar.get('exposedPersonPositionId')?.value).slice(0, 1));
    this.sendEmitter.emit(this.formFamiliar.value);
    this.formFamiliar.reset();
  }
  adicionar() {
    this.form.get('exposedPersonStatementTypeId')?.setValue(this.tipoCargo);
    this.form.get('exposedPersonPositionId')?.setValue((this.form.get('exposedPersonPositionId')?.value).slice(0, 1));
    this.sendEmitter.emit(this.form.value);
    this.form.reset();
  }
}
